// Dependencies
import React from 'react';

// Modules
import { withRouter } from 'react-router'
import { connect } from 'react-redux';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

// App
import { serverUrl, apiEndpoints } from "../../config";
import { getOnlineNode } from '../../core/getNode';
import { postNode } from '../../core/postNode';
import { deleteRequest } from '../../core/delete';
import PostTitle from '../../partials/postTitle';
import PostBody from '../../partials/postBody';
import { alertMessages } from '../../partials/alertMessages';
import Error from '../../partials/error';
import SkeletonSingleScreen from '../../partials/skeleton-screens/skeletonSingleScreen';
import CommentSection from '../../partials/comments/commentSection';
import { formatTime } from '../../utils/helpers';

// UI components
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { MessageSquare, Clock, Tag } from 'react-feather';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp as faThumbsUpSolid, faHeart as faHeartSolid, faSurprise as faSurpriseSurpriseSolid } from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp as faThumbsUpRegular, faHeart as faHeartRegular, faSurprise as faSurpriseSurpriseRegular } from '@fortawesome/free-regular-svg-icons';
import { ArrowBack } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { Chip, Typography } from '@mui/material';
import SinglesHeader from '../../partials/singlesHeader';

// Dummy data

export default function VideosSingle(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isPaginating, setIsPaginating] = useState(false);
  const [post, setPost] = useState(null);
  const [isCommentsLoading, setIsCommentsLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [total_pages, setTotal_Pages] = useState(0);
  const [isReactionsLoading, setIsReactionsLoading] = useState(true);
  const [categoryName, setCategoryName] = useState(null);
  const [reactions, setReactions] = useState(
    {
      hasReacted: false,
      likes: 0,
      love: 0,
      suprised: 0,
    },);

  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const user = useSelector((state) => state).authReducer.user;
  const params = useParams()


  useEffect(() => {
    loadNode()
  }, []);
  useEffect(() => {
    if (post) {
      getCategory()
    }
  }, [post]);

  /**
   * @function setData
   * @description Updates the state of the component upon data retrival
   * @param {object} _data
   * @param {object} _realm
   */

  const setData = (_data) => {
    setPost(_data);
    console.log('video data', _data);
    setIsLoading(false);
    setIsError(false);
    // getComments();
    // getReactions();
    getCategory(_data.field_category);
  }

  /**
   * @function setError
   * @description Updates the state of the component upon an error
   * @param {boolean} _isError
   * @param {int} _errorStatus
   * @param {string} _errorMessage
   */
  const setError = (_isError, _errorStatus, _errorMessage) => {
    setIsLoading(false);
    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  const loadNode = () => {
    const nid = params.id;

    if (nid) {
      getContent(nid);
      // getComments(nid)
    } else {
      setError(true, 0, alertMessages.contentError);
    }
  };

  /**
   * @function getContent
   * @description Retrieves the data from an API / Fallback to local realm object if there is no connection
   */
  const getContent = (nid) => {
    let path = `${apiEndpoints.videos}/all/${nid}?_format=json&status=1&promote=1`

    getOnlineNode(path, user.access_token)
      .then((response) => {
        if (response.data.rows.length > 0) {
          setData(response.data.rows[0]);
        } else {
          setError(true, 200, alertMessages.noData);
        }
      })
      .catch((_error) => {
        // if (_error.response) {
        //   setError(
        //     true,
        //     _error.response.status,
        //     _error.response.statusText,
        //   );
        // }
        // else if (_error.request) {
        //   setError(true, 0, alertMessages.requestError.message);
        //   console.log('this got triggered 1');
        // } else {
        //   setError(true, 0, alertMessages.unkownError.message);
        //   console.log('this got triggered 2');
        // }
      });
  };

  const getCategory = (id) => {
    // if (post.field_category) {
    //   getOnlineNode(
    //     // `api/categories?vid=news`,
    //     `api/categories?tid=${post.field_category}`,
    //     user.access_token,
    //   )
    //     .then((response) => {
    //       let categoryTemp = response.data.length > 0 ? response.data[0] : { title: "" }
    //       setCategoryName(categoryTemp.title)
    //     })
    //     .catch((_error) => {
    //       if (_error.response) {
    //         setError(
    //           true,
    //           _error.response.status,
    //           _error.response.statusText,
    //         );
    //       } else if (_error.request) {
    //         //console.log('@rest request: ', _error.request);
    //         setError(true, 0, alertMessages.requestError.message);
    //       } else {
    //         //console.log('@rest unknown: ', _error);
    //         setError(true, 0, alertMessages.unkownError.message);
    //       }
    //     });
    // }
  }

  const renderPostVideo = (post) => {
    return (
      <div className="post-video-container">
        <video controls className='post-video'>
          <source src={`${serverUrl}${post.uri}`} alt={`Video for ${post.title}`}/>
        </video>
      </div>
    );
  };

  const renderPostDescription = (post) => {
    return (
      <Typography
        className='post-video-description'
        owner='client'
        variant='body1'
        color='clientText.main'
        weight='light'
      >
      </Typography>
    )
  }

  if (isLoading) {
    return <SkeletonSingleScreen />;
  } else {
    if (isError) {
      return (
        <Error
          status={errorStatus}
          message={errorMessage}
        />
      );
    } else {

      let category = 'Uncategorised';

      if (categoryName) {
        category = categoryName;
      }

      if (post.categoryLabel) {
        category = post.categoryLabel;
      }

      return (
        <main className="videos  single">
          <article className="article">
            <SinglesHeader 
              route={"/videos"}
              backBtnText={"Video Library"}
              category={category}
              timestamp={post.created}
              title={post.title}
            />
            {renderPostVideo(post)}
            <PostBody body={post.body} />
            <div className="article__body">
            </div>
            <CommentSection nid={post.nid} />
          </article>
        </main>
      );
    }
  }
}

